<template>
  <main-view :client="profileClient">
    <suspense-view />
  </main-view>
</template>

<script lang="ts">
  import { defineComponent, ref, watch } from 'vue';
  import MainView from '@/views/main/MainView.vue';
  import SuspenseView from '@/components/load-application/SuspenseView.vue';
  import ProfileClient from '@/service/profile/profileClient';
  import UserService from '@/service/user/UserService.ts';
  import { getCurrentUser, useFirebaseStorage, useFirestore } from 'vuefire';
  import { useSettingStore } from '@/stores/settings';
  import { saveWeekSettings } from '@/service/profile/weekSettings';

  export default defineComponent({
    name: 'AuthenticatedRoute',
    components: { SuspenseView, MainView },
    async setup() {
      // Shared with outside tools (the MCP server), which plan by date; set
      // up before any await, so it ends with the component
      const settingStore = useSettingStore();
      const firestore = useFirestore();
      const signedIn = ref<string>();
      watch([signedIn, () => settingStore.weekStartDay], ([uid, day]) => {
        if (uid) {
          saveWeekSettings(firestore, uid, day).catch(() => {
            // Offline: saved the next time
          });
        }
      });

      const user = await getCurrentUser();
      if (!user) {
        throw new Error('Login Required!');
      }
      const userService = new UserService(useFirestore(), user);
      const profileClient = new ProfileClient(
        user,
        useFirestore(),
        useFirebaseStorage(),
      );
      await userService.init();
      signedIn.value = user.uid;

      return { profileClient };
    },
  });
</script>
